
import { Component, Vue, Prop } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import SubjectTip from '@/components/organisms/SubjectTip.vue'
import GradeTip from '@/components/organisms/GradeTip.vue'
import { StudyCategory } from '@/models/StudyCategory'
import DateUtils from '@/utils/DateUtils'

/**
 * 教材パネル(各学習タイプで共通)
 */
@Component({
  components: {
    ImageBase,
    PanelFrame,
    SubjectTip,
    GradeTip,
  },
})
export default class StudyCategoryPanel extends Vue {
  /** 教材情報 */
  @Prop()
  private studyCategory!: StudyCategory.LearningStatusStudyCategory

  /** 進捗の表示 */
  @Prop({ default: true })
  private showProgress!: boolean

  /** 教材パネルクリック時のイベント */
  @Prop()
  private eventClickStudyCategoryPanel!: (studyCategoryId: number) => void

  /** 教科コード */
  private subjectCode: string = ''

  /** 学年コード */
  private gradeCode: string = ''

  /**
   * 最終学習日付
   *
   * @returns フォーマットされた日付
   */
  private get date(): string {
    if (this.studyCategory.historyDate === null) {
      return '----/--/--'
    }
    return DateUtils.format(this.studyCategory.historyDate, false)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    // クッキー取得
    this.subjectCode = await this.$appCookies.studentMenuState.subjectCode.get()
    this.gradeCode = await this.$appCookies.studentMenuState.gradeCode.get()
  }
}
